import { z } from "zod";

export const timeLineSchema = z.object({
	language: z.string().optional(),
	category: z.string().optional(),
	event: z.string(),
	urgency: z.enum(["Immediate", "Expected", "Future", "Past"]),
	severity: z.enum(["Extreme", "Severe", "Moderate", "Minor"]),
	certainty: z.enum(["Observed", "Likely", "Possible", "Unlikely"]),
	effective: z.coerce.date(),
	onset: z.coerce.date(),
	expires: z.coerce.date(),
	area: z.object({
		areaDesc: z.string(),
		polygon: z.string().optional(),
	}),
});

export type TimeLineType = z.infer<typeof timeLineSchema>;
